angular.module('impactx.cancellation').controller('CancelRequestCtrl', [
    '$scope',
    'dataGen',
    'selectedListItems',
    '$mdToast',
    'BackService',
    'WarningService',
    '$redirect',
    'ToolbarService',
    '$mdDialog',
    CancelRequestCtrl]);

function CancelRequestCtrl($scope, dataGen, selectedListItems, $mdToast, BackService, WarningService, $redirect, ToolbarService, $mdDialog) {
    var self = this;
    var params = [$redirect.getLastParameters()];
    $scope.selectedItems = [];
    dataGen.getData($scope, {selected: params}, '/purchaserequest/cancellation/view').then(function () {
        defineButtons();
    });

    this.getOldPrice = function (items) {
        var sum = 0;
        angular.forEach(items, function (entry) {
            sum += entry.price.netValue.value / 100 * entry.oldAmount;
        });
        return sum;
    };

    this.getNewPrice = function (items) {
        var sum = 0;
        angular.forEach(items, function (entry) {
            sum += entry.price.netValue.value / 100 * entry.newAmount;
        });
        return sum;
    };

    this.save = function (event) {
        var changedAmounts = false;
        angular.forEach($scope.data.cancellation.items, function (entry) {
            if (entry.oldAmount > entry.newAmount) {
                changedAmounts = true;
            }
        });
        if (changedAmounts) {
            return dataGen.post({}, {selected: $scope.data.cancellation.items}, "/purchaserequest/cancellation/save").then(function () {
                BackService.back();
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.success)
                        .position("bottom right")
                        .hideDelay(10000)
                );
            }, function () {
            })
        }
        else {
            WarningService.showWarningDialog(null, event, $scope.trns.warning, "",
                $scope.trns.abort, [$scope.trns.noChangedItem], null, true);
        }
    };

    this.cancelBasketItemGroup = function (basketItemGroupId) {
        angular.forEach($scope.data.cancellation.items, function (entry) {
            if (entry.basketItemGroupId === basketItemGroupId) {
                entry.newAmount = 0;
            }
        });
    };

    $scope.selectItem = function (item) {
        if (item.selected) {
            var index = $scope.selectedItems.indexOf(item);
            if (index > -1) {
                $scope.selectedItems.splice(index, 1);
            }
        }
        else {
            $scope.selectedItems.push(item);
        }
        item.selected = !item.selected;
    };

    self.editItem = function(ev) {
        $mdDialog.show({
            controller: 'EditRequestItemCancelCtrl',
            templateUrl: 'shared/requestitem/templates/requestitem-cancel-dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                trns: $scope.trns,
                item: $scope.selectedItems[0]
            }
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.cancelDialogData
                }
            },
            {
                label: $scope.trns.edit,
                action: self.editItem,
                type: 'dialogaction',
                condition: canEditItem
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canEditItem() {
        return isEditable() && $scope.selectedItems.length === 1;
    }
}